"use client";
import Link from "next/link";
import { menuStore } from "../MenuInner";

type Props = {
  destination: {
    title: string;
    alias: string;
    departures: number;
  };
};
export const Destination = ({ destination }: Props) => {
  return (
    <Link
      href={`/voyages-culturels/${destination.alias}/`}
      className="text-xs font-medium text-tx-1 hover:text-pr-1 group w-fit px-1 py-[3px] rounded-sm bg-transparent hover:bg-bg-2 -mx-1 -my-[3px]"
      onClick={() => menuStore.set(null)}
    >
      {destination.title}{" "}
      <span className="text-tx-2 group-hover:text-pr-1 whitespace-nowrap">{`(${destination.departures} départ${destination.departures > 1 ? "s" : ""})`}</span>
    </Link>
  );
};
